// ============= Billing Badge ================
type BillingBadgeProps = {
  /** The billing period to display (e.g., “monthly” or “annually”). */
  billingPeriod: string;
};

export function BillingBadge({ billingPeriod }: BillingBadgeProps) {
  return (
    <span className="inline-flex max-w-max items-center justify-center gap-1 rounded-sm bg-[#F8F2DB] px-1.5 py-1 font-archivo text-[12px] leading-[14.4px] font-semibold tracking-[0.24px] text-[#2C260F] capitalize outline-1 -outline-offset-1 outline-[#DCBF49] outline-solid">
      Billed {billingPeriod}
    </span>
  );
}
